module.exports = __webpack_public_path__ + "img/pos.259022ae.svg";